// store/modules/popup.ts (or .js if using JS)

import { ActionContext } from 'vuex';

interface PopupState {
  showPopup: boolean;
  popupOptions: {
    title: string;
    text: string;
    buttonLabel: string;
  };
}

const state: PopupState = {
  showPopup: false,
  popupOptions: {
    title: '',
    text: '',
    buttonLabel: '',
  },
};

const mutations = {
  SHOW_POPUP(state: PopupState, options: Partial<PopupState['popupOptions']>) {
    state.showPopup = true;
    state.popupOptions = {
      ...state.popupOptions,
      ...options,
    };
  },
  HIDE_POPUP(state: PopupState) {
    state.showPopup = false;
    state.popupOptions = {
      title: '',
      text: '',
      buttonLabel: '',
    };
  },
};

const actions = {
  showPopup(
    { commit }: ActionContext<PopupState, any>,
    options: Partial<PopupState['popupOptions']> = {}
  ) {
    commit('SHOW_POPUP', options);
  },
  hidePopup({ commit }: ActionContext<PopupState, any>) {
    commit('HIDE_POPUP');
  },
};

const getters = {
  showPopup: (state: PopupState) => state.showPopup,
  popupOptions: (state: PopupState) => state.popupOptions,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
